export const getSlaThreshold = (row) => {
    return row.sla_minimum_threshold
        ?? row.client_product?.sla_minimum_threshold
        ?? row.client_product?.product?.sla_minimum_threshold
        ?? null;
};

export const getSlaThresholdForExcel = (row) => {
    const threshold = getSlaThreshold(row);

    return null !== threshold ? `${threshold}%` : '';
};
